import { hotRanking } from "@/mocks/home";

const trendIcon: Record<string, { icon: string; cls: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "text-primary-600" },
  down: { icon: "ri-arrow-down-line", cls: "text-secondary-600" },
  flat: { icon: "ri-subtract-line", cls: "text-foreground-400" },
};

export default function HotRanking() {
  return (
    <section id="hot" className="w-full px-4 md:px-10 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
        <div className="lg:col-span-4">
          <span className="text-xs md:text-sm tracking-[0.3em] text-primary-600 uppercase">
            Hot Ranking
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            追新热榜
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            按实时热度排序，涨得最快的那几条通常就是最快黑料。
            榜单每十五分钟重排一次，热度以站内互动量折算。
          </p>
          <div className="mt-6 rounded-lg border hairline bg-background-100/70 p-4 md:p-5">
            <p className="text-xs text-foreground-500">当前更新节奏</p>
            <p className="mt-1 font-heading text-lg font-bold text-foreground-950">
              平均每 42 分钟一条新料
            </p>
            <div className="mt-4 flex items-center gap-2">
              <i className="ri-live-line text-primary-600 text-lg" />
              <span className="text-sm text-foreground-700">榜单实时同步中</span>
            </div>
          </div>
        </div>

        <div className="lg:col-span-8">
          <ol className="rounded-lg border hairline bg-background-50 divide-y divide-foreground-950/8 overflow-hidden">
            {hotRanking.map((item) => {
              const t = trendIcon[item.trend] ?? trendIcon.flat;
              return (
                <li
                  key={item.rank}
                  className="flex items-center gap-4 md:gap-6 px-4 md:px-6 py-4 hover:bg-background-100/70 transition-colors"
                >
                  <span
                    className={`w-9 md:w-11 shrink-0 font-heading text-2xl md:text-3xl font-black ${
                      item.rank <= 3 ? "text-primary-500" : "text-foreground-300"
                    }`}
                  >
                    {String(item.rank).padStart(2, "0")}
                  </span>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 truncate">
                      {item.title}
                    </h3>
                    <div className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                      <span className="inline-flex items-center gap-1.5">
                        <i className="ri-fire-line text-sm" />
                        {item.heat}
                      </span>
                      <span className={`inline-flex items-center gap-1.5 ${t.cls}`}>
                        <i className={`${t.icon} text-sm`} />
                        {item.trend === "up" ? "上升" : item.trend === "down" ? "回落" : "持平"}
                      </span>
                    </div>
                  </div>
                  <i className="ri-arrow-right-s-line text-xl text-foreground-400 shrink-0" />
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}